import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/video-generation', label: 'Video Generation' },
    { path: '/streaming-avatar', label: 'Streaming Avatar' },
    { path: '/jobs', label: 'Jobs' },
    { path: '/api-docs', label: 'API Docs' }
];

const Navbar = () => {
    const location = useLocation();
    const [mobileOpen, setMobileOpen] = useState(false);
    const logoSrc = `${process.env.PUBLIC_URL || ''}/oygen-logo.svg`;

    const toggleMobile = () => setMobileOpen((open) => !open);
    const closeMobile = () => setMobileOpen(false);

    return (
        <header className="navbar">
            <div className="container navbar__container">
                <Link to="/dashboard" className="navbar__brand" onClick={closeMobile}>
                    <div className="navbar__logo-shell">
                        <img src={logoSrc} alt="OyGen logo" className="navbar__logo" />
                        <span className="navbar__logo-glow" />
                    </div>
                    <span className="navbar__title">OyGen</span>
                </Link>

                <nav className="navbar__links">
                    {navItems.map((item) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={`navbar__link${isActive ? ' navbar__link--active' : ''}`}
                            >
                                <span>{item.label}</span>
                            </Link>
                        );
                    })}
                </nav>

                <button
                    className={`navbar__toggle${mobileOpen ? ' navbar__toggle--open' : ''}`}
                    aria-expanded={mobileOpen}
                    aria-label="Toggle navigation menu"
                    onClick={toggleMobile}
                >
                    <span />
                    <span />
                    <span />
                </button>
            </div>

            <div className={`navbar__mobile${mobileOpen ? ' navbar__mobile--open' : ''}`}>
                <div className="navbar__mobile-inner">
                    {navItems.map((item) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={`navbar__mobile-link${isActive ? ' navbar__mobile-link--active' : ''}`}
                                onClick={closeMobile}
                            >
                                {item.label}
                            </Link>
                        );
                    })}
                </div>
            </div>
        </header>
    );
};

export default Navbar;
